// extracted by mini-css-extract-plugin
export default {"container":"AdminBoard_container__jiAKf","storageTable":"AdminBoard_storageTable__0hmAR","saveButton":"AdminBoard_saveButton__5DUaw","addButton":"AdminBoard_addButton__z6T2K"};